import { render, staticRenderFns } from "./SignInOrUpForm.vue?vue&type=template&id=03bd28c6"
import script from "./SignInOrUpForm.vue?vue&type=script&lang=ts"
export * from "./SignInOrUpForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports